// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel-3d-container figure{margin:0}.carousel-3d-container figcaption{background-color:rgba(0,0,0,.5);color:#fff;position:absolute;bottom:0;padding:15px;font-size:12px;min-width:100%;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
